module.exports = __webpack_public_path__ + "img/game01.13e1cf25.png";